import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { CmsTasksComponent } from './CmsTasks/cms-tasks.component';
import { MatTableModule } from '@angular/material/table';

import { TaskManagerComponent } from './taskManager.component';
import { MatDatepickerModule, MatInputModule, MatNativeDateModule, MatSortModule } from '@angular/material';
import { Utils } from '@src/utils/util';

@NgModule({
    imports: [
        SharedModule,
        MatTableModule, 
        MatSortModule, 
        MatDatepickerModule, 
        MatInputModule, 
        MatNativeDateModule ,
    ],
    declarations: [TaskManagerComponent,CmsTasksComponent],
    entryComponents: [TaskManagerComponent],
    exports: [TaskManagerComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class TaskManagerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/taskManager-ang7/taskManager.moudle.ts